<div class="billing-container">
  <!-- Plan Details -->
  <div class="plan-card">
    <div class="plan-header">
        <!-- Left Side: Plan Name & Type -->
        <div class="plan-info">
            <h2>
                {{ plan.name }} <span class="plan-type">{{ plan.type }}</span>
            </h2>
        </div>
    
        <!-- Right Side: Price & Currency -->
        <div class="plan-price">
            <h1>
                {{ plan.currency }} {{ plan.price }}
                <span>/{{ plan.billing.toLowerCase() }}</span>
            </h1>
        </div>
    </div>
    <div class="plan-usage">
      <p>{{ plan.users }} of {{ plan.maxUsers }} users</p>
      <div class="progress-bar">
        <div
          class="progress"
          [style.width.%]="(plan.users / plan.maxUsers) * 100"
        ></div>
      </div>
    </div>
    <div class="plan-actions">
      <button class="btn-primary">View Current Bill</button>
      <a class="upgrade-link">Upgrade plan →</a>
    </div>
  </div>

  <!-- Billing History -->
  <div class="billing-history-container">
    <div class="billing-actions">
        <h3>Billing history</h3>
        <button class="btn-download"><i class="bi bi-cloud-arrow-down"></i> Download all</button>
    </div>
    
    <div class="billing-history">
      <table>
        <thead>
          <tr>
            <th><input type="checkbox" /></th>
            <th>Invoice</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (bill of billingHistory; track bill.invoice) {
            <tr>
              <td><input type="checkbox" /></td>
              <td>{{ bill.invoice }}</td>
              <td>{{ plan.currency }} {{ bill.amount.toFixed(2) }}</td>
              <td>{{ bill.date }}</td>
              <td>
                <span class="status-pill paid">Paid</span>
              </td>
              <td>
                <button
                  class="download-btn"
                  (click)="downloadInvoice(bill.invoice)"
                >
                <i class="bi bi-cloud-arrow-down"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
